const cleanPayload = (payload = {}) => {
	return Object.entries(payload).reduce((acc, [key, value]) => {
		if (value !== undefined && value !== null) {
			acc[key] = value;
		}
		return acc;
	}, {});
};

const getIumcFromStorage = () => {
	try {
		const raw = localStorage.getItem('ct_mc');
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		return parsed?.mcid || null;
	} catch (_) {
		return null;
	}
};

const normalizeIdentity = payload => {
	const userId = payload?.user_id || null;
	const iumc = payload?.userid || getIumcFromStorage() || userId || null;

	return {
		...payload,
		ifUserId: userId,
		ifIumc: iumc,
	};
};

export const trackGa4CatalogEvent = (eventName, payload = {}) => {
	if (!eventName) return;
	const identity = normalizeIdentity(payload);
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		...cleanPayload({
			...payload,
			user_id: identity.ifUserId,
			userid: identity.ifIumc,
		}),
	});

	console.log(`📊 GA4 Event Tracked: ${eventName}`, {
		event: eventName,
		...cleanPayload({
			...payload,
			user_id: identity.ifUserId,
			userid: identity.ifIumc,
		}),
	});
};

export const trackGa4ElementEvent = (eventName, elementId, payload = {}) => {
	if (!eventName || !elementId) return;
	trackGa4CatalogEvent(eventName, {
		id: elementId,
		...payload,
	});
};
